<script>
  import IconTweet from '@/components/atoms/IconTweet'
  import IconMore from '@/components/atoms/IconMore'
  import questionsDef from '@/const/questions'

  export default {
    name: 'HimekuriInput',
    components: {
      IconTweet,
      IconMore
    },
    data() {
      return {
        currentIndex: 0,
        questions: [],
        currentQuestion: questionsDef[0],
        answerValue: '',
        processing: true,
        placeholder: '',
      }
    },
    computed: {
      isChangedQuestion() {
        const MAX = 5;
        const Q_MAX = 24;
        if(this.$store.state.currentQuestionCount < 24) {
          if(!this.$store.state.isLimited) return true;
          return (this.$store.state.todaysQuestionNum < MAX);
        } else {
          return false;
        }
      },
      isCheckMoreQuestion() {
        const MAX = 5;
        const Q_MAX = 24;
        let qNum = Q_MAX - this.$store.state.answeredIds.length;
        if(qNum > 0) {
          if(!this.$store.state.isLimited) return true;
          return (this.$store.state.todaysAnswerNum < MAX);
        } else {
          return false;
        }
      }
    },
    mounted() {
      // 回答済みの質問を除外
      this.questions = questionsDef.filter(o => {
        return this.$store.state.answeredIds.indexOf(o.id) < 0;
      });
      this.currentQuestion = this.questions[0];
      this.placeholder = this.currentQuestion.example;
      this.$store.commit('setCurrentQuestionId', this.currentQuestion.id);
    },
    methods: {
      changeQuestion() {
        // 質問を変える
        const MAX = 5;
        const Q_MAX = 24;
        if(this.isChangedQuestion && this.$store.state.currentQuestionCount < 24) {
          if(this.processing) {
            this.processing = false;
            let i = this.currentIndex;
            if(!(this.$store.state.answeredIds.indexOf(this.currentQuestion.id) < 0)) {
              i = 0;
            } else {
              let qNum = Q_MAX - this.$store.state.answeredIds.length;
              let othersQNum = MAX - 1 - this.$store.state.todaysAnswerNum;
              if(qNum < 5) {
                if(qNum <= othersQNum || othersQNum < 0) {
                  i < (qNum - 1) ? i++ : i = 0;
                } else {
                  i < othersQNum ? i++ : i = 0;
                }
              } else {
                if(this.$store.state.isLimited) {
                  i < othersQNum ? i++ : i = 0;
                } else {
                  i < (MAX - 1) ? i++ : i = 0;
                }
              }
            }
            this.currentIndex = i;
            this.currentQuestion = this.questions[this.currentIndex];
            this.answerValue = '';
            this.$store.commit('setCurrentQuestionId', this.currentQuestion.id);
            setTimeout(() => {
              this.placeholder = this.currentQuestion.example;
            }, 300);
            setTimeout(() => {
              this.processing = true;
            }, 500);
          }
        }
      },
      postAnswer() {
        if(!this.answerValue) return;
        // 回答を記録する
        this.$store.commit('addAnsweredId', this.currentQuestion.id);
        this.$store.commit('addTodaysAnswerNum');
        this.$store.dispatch('openModalStamp');
        this.$store.commit('addLastAnswerDate');
        this.$store.commit('toggleAnswered', true);
        // localStrageに保存
        this.$store.dispatch('doSave');
      },
      async back() {
        // もう1回回答する
        await this.filterQuestion();
        await this.changeQuestion();
        this.currentIndex = 0;
        this.$store.commit('addCurrentQuestionCount');
        this.$store.commit('addTodaysQuestionNum');
        this.$store.commit('toggleAnswered', false);
      },
      filterQuestion() {
        this.questions = this.questions.filter(o => {
          return o.id !== this.currentQuestion.id
        });
      },
      openTwitter(text, url, hash1, hash2) {
        let hashtags = [hash1, '日めくりクエスチョン', '住友生命Vitality'];
        let hash = hashtags.join(',');
        if(hash2) {
          hash += ',' + hash2;
        }
        const turl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&hashtags=${encodeURIComponent(hash)}&url=${url}`;
        this.$store.commit('toggleAnswered', true);
        window.open(turl,'_blank');
      },
      getUrl() {
        let hashtags = [this.currentQuestion.hash1, '日めくりクエスチョン', '住友生命Vitality'];
        let hash = hashtags.join(',');
        if(this.currentQuestion.hash2) {
          hash += ',' + this.currentQuestion.hash2
        }
        return `https://twitter.com/intent/tweet?text=${encodeURIComponent(this.answerValue)}&hashtags=${encodeURIComponent(hash)}&url=${this.currentQuestion.ogp_url}`;
      },
    },
  }
</script>

<template lang="pug">
  transition(
    name = 'himekuri-input'
    )
    .himekuri-input
      .himekuri-input__question(
        v-for = '(question, index) in questions'
        :key = 'index'
        )
        transition(
          name = "question-fade"
          )
          .himekuri-input__question-in(
            v-show = 'index === currentIndex'
            )
            .himekuri-input__question-text
              |{{ question.text }}
            a.himekuri-input__question-link(
              v-if = 'question.link_text !== "" && question.link_href !== ""'
              :href = 'question.link_href'
              target = '_blank'
              )
              |{{ question.link_text }}
      transition(
        name = "question-fade"
        )
        .himekuri-input__answer(
          v-if = '$store.state.isAnswered === false'
          key = 'answer'
          )
          textarea.himekuri-input__textarea(
            row = '60'
            col = '4'
            :placeholder = 'placeholder'
            v-model = 'answerValue'
            )
          .himekuri-input__textarea-cursor(
            :class = '{ hasText : answerValue }'
            )
          .himekuri-input__change(
            @click = 'changeQuestion'
            :class = '{ disabled : !isChangedQuestion }'
            )
            .himekuri-input__change-icon
              img(
                src = '~@/assets/img/icon_change.svg'
                alt = ''
                )
            |クエスチョンを変える
          a.himekuri-input__btn(
            :href = 'getUrl()'
            target = '_blank'
            @click = 'postAnswer'
            :class = '{ disabled : !answerValue }'
            )
            .himekuri-input__btn-in
              IconTweet.himekuri-input__tweet-icon
              |これで答える！
        .himekuri-input__answered(
          v-else
          key = 'answered'
          )
          .himekuri-input__answered-wrap
            .himekuri-input__answered-heading
              |あなたのアンサー
            .himekuri-input__answered-text
              |{{ answerValue }}
          .himekuri-input__congratulations(
            v-if = '$store.state.answeredIds.length === 24'
            )
            img(
              src = '~@/assets/img/text_congratulations_finish.svg'
              alt = 'congratulations'
              )
            |これからも住友生命「Vitality」を
            br.brNoto
            |お楽しみください。
          button.himekuri-input__btn.primary(
            v-else-if = 'isCheckMoreQuestion'
            @click = 'back'
            )
            .himekuri-input__btn-in
              IconMore.himekuri-input__more-icon
              |もう一問回答する
          .himekuri-input__congratulations(
            v-else
            )
            img(
              src = '~@/assets/img/text_congratulations.svg'
              alt = 'congratulations'
              )
            |1日に回答できるのは5問までです。
            br.brNoto
            |また明日アクセスしてみてください！
      .himekuri-input__edge
</template>

<style lang="scss">
  .himekuri-input {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
    &__question {
      width: calc(100% - 40px);
      height: 142px;
      position: absolute;
      top: 0;
      left: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
    }
    &__question-in {
      position: relative;
      width: 100%;
    }
    &__question-text {
      position: relative;
      width: 100%;
      line-height: (34 / 26);
      @include fontSize(26);
      font-weight: 700;
    }
    &__question-link {
      position: relative;
      margin-top: 5px;
      color: $primary-color;
      @include fontSize(12);
      z-index: 100;
    }
    &__answer,
    &__answered {
      width: calc(100% - 40px);
      display: flex;
      flex-direction: column;
      align-items: center;
      position: absolute;
      top: 142px;
      left: 20px;
    }
    &__textarea {
      width: 100%;
      height: 110px;
      box-sizing: border-box;
      display: block;
      line-height: (18 / 15);
      margin-bottom: 15px;
      padding: 10px;
      border: 1px solid #ddd;
      border-radius: 5px;
      @include fontSize(16);
      position: relative;
      &-cursor {
        display: block;
        position: absolute;
        top: 10px;
        left: 11px;
        width: 1px;
        height: 22px;
        content: '';
        background: #000;
        &.hasText {
          display: none;
        }
      }
      &:focus + &-cursor {
        display: none;
      }
    }
    &__change {
      cursor: pointer;
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      color: $primary-color;
      @include fontSize(15);
      &.disabled {
        color: #ddd;
        cursor: auto;
      }
      &.disabled & {
        &-icon {
          background-color: #ddd;
        }
      }
    }
    &__change-icon {
      width: 20px;
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 5px;
      border-radius: 50%;
      background-color: $primary-color;
    }
    &__btn {
      display: block;
      width: 100%;
      height: 55px;
      box-sizing: border-box;
      cursor: pointer;
      padding-bottom: 4px;
      border-radius: 28px;
      @include fontSize(18);
      font-weight: bold;
      color: #fff;
      background-color: $color-twitter;
      text-decoration: none;
      &-in {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      &.primary {
        background-color: $base-color;
        color: $primary-color;
        border: 3px solid $primary-color;
      }
      &:disabled,
      &.disabled {
        pointer-events: none;
        background-color: #ddd;
      }
    }
    &__tweet-icon {
      margin-top: 2px;
      margin-right: 12px;
    }
    &__more-icon {
      margin-top: 2px;
      margin-right: 8px;
    }
    &__answered-wrap {
      width: 100%;
      height: 140px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      overflow-y: scroll;
      margin-bottom: 20px;
      padding: 20px 10px;
      border: 2px solid #111;
      border-radius: 5px;
    }
    &__answered-heading {
      line-height: 1.5;
      margin-bottom: 10px;
      @include fontSize(16);
    }
    &__answered-text {
      line-height: (26 / 20);
      @include fontSize(20);
      font-weight: 700;
    }
    &__edge {
      width: 24px;
      height: 24px;
      overflow: hidden;
      position: absolute;
      bottom: 0;
      right: 0;
      background-color: $primary-color;
      &:after {
        width: 100%;
        height: 100%;
        content: '';
        display: block;
        background-color: #ddd;
        transform-origin: right top;
        transform: skewX(-45deg);
      }
    }
    &__congratulations {
      text-align: center;
      @include fontSize(12);
      line-height: (16/12);
      img {
        display: block;
        margin-top: -8px;
        margin-bottom: 7px;
      }
    }
    &__edge {
      width: 24px;
      height: 24px;
      overflow: hidden;
      position: absolute;
      bottom: 0;
      right: 0;
      &:after {
        width: 100%;
        height: 100%;
        content: '';
        display: block;
        background-color: #ddd;
        transform-origin: right top;
        transform: skewX(-45deg);
      }
    }

    //
    // 表示・非表示アニメーション
    &.himekuri-enter {
      opacity: 0;
    }
    &.himekuri-enter-to {
      opacity: 1;
      transition-duration: 0.2s;
      transition-delay: 0.65s;
      transition-property: opacity;
    }

    //
    // クリック誘導アニメーション
    &__btn {
      &-in {
        animation: blink 1.6s infinite ease;
      }
      &.disabled &-in {
        animation: none;
      }
    }

    //
    // 入力誘導アニメーション
    &__textarea-cursor {
      animation: blink 1s infinite steps(1);
    }
    .question-fade-leave-active {
      transition: opacity .3s ease;
    }
    .question-fade-enter-active {
      transition: opacity .3s ease .3s;
    }
    .question-fade-enter,
    .slide-fade-leave-to {
      opacity: 0;
    }
  }
</style>
